import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Por seguridad, si no se especifican roles permitidos, no se debe permitir el acceso.
  // Cada ruta protegida debe definir explÃ­citamente quiÃ©n puede acceder a ella.
  if (!allowedRoles || allowedRoles.length === 0) {
    console.error("ProtectedRoute no tiene 'allowedRoles' definidos.");
    return <Navigate to="/" replace />;
  }

  // Comprobar si el rol del usuario estÃ¡ en la lista de roles permitidos (case-insensitive).
  const userRole = (user?.role || '').trim().toLowerCase();
  const allowed = allowedRoles.map(r => r.toLowerCase());

  console.log("ProtectedRoute Check:", { userRole, allowed, match: allowed.includes(userRole) });

  if (!allowed.includes(userRole)) {
    // Si el usuario no tiene el rol correcto, redirigirlo a su pÃ¡gina de inicio designada.
    const homePath =
      userRole === 'admin'
        ? '/admin'
        : userRole === 'colaborador'
          ? '/colaborador'
          : userRole === 'miembro'
            ? '/miembro'
            : userRole === 'paciente' || userRole === 'cliente'
              ? '/user/dashboard'
              : '/';
    return <Navigate to={homePath} replace />;
  }


  return children ? children : <Outlet />;
};

export default ProtectedRoute;



